module.exports = __webpack_public_path__ + "img/Abfahrk_status_offen.7adeeb1d.svg";